import moment from 'moment';

export function invoiceDate(date: string) {
  const parsed = moment.utc(date, 'YYYY-MM-DD');

  return parsed.isValid() ? parsed.format('DD MMM YYYY') : '';
}
